import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Button,
  TablePagination,
  CircularProgress,
  Box,
  IconButton,
  Checkbox,
  TextField,
} from "@mui/material";
import {
  Add,
  Check,
  Clear,
  ClearTwoTone,
  DoneTwoTone,
  DownloadDoneTwoTone,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Remove,
  Sell,
  UnfoldMore,
} from "@mui/icons-material";
import moment from "moment/moment";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
  "& svg": {
    position: "relative",
    top: "5px",
  },
  "&:last-child": {
    // paddingRight: 64,
    "& svg": {
      // display: 'none',
      // color: theme.palette.primary.dark
    },
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const QuantityBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export default function TableComponentPickup({
  productQuantity,
  //   setProductQuantity,
  check,
  setCheck,
  handleChange,
  handleChangeLocation,
  handleCheck,
  handleAddQuantity,
  handleRemoveQuantity,
  rows,
  columns,
  footer,
  modifiedData,
}) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = "https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png";
  }

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {columns.map((col, index) => (
                <StyledTableCell align={(index === 6 || index === 7) ? "center" : "left"}>
                  {col.name}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          {rows && rows.length > 0 ?
            <TableBody>
              {rows && rows
                //   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                //.filter(row => row.isFulfilled !== 1)
                .map((row) => {
                  var curr = {};
                  modifiedData.length > 0 && modifiedData.map(m => {
                    if (m.id === row.id) {
                      curr = m;
                    }
                  })

                  const salesQty = parseInt(row?.actual_total_lines) || 0;
                  const fulfilledQty = parseInt(row?.totalFulfilledQty) || 0;
                  //const remainingQty = salesQty - fulfilledQty;
                  const remainingQty = parseInt(row?.quantity) || 0;

                  return (

                    <StyledTableRow key={Math.random()}>
                      {columns.map((col, index) =>
                        col.id === "imageUrl" ? (
                          <StyledTableCell align="left">
                            <img
                              src={row?.ax_details?.imageUrl || `https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png`}
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                              }}
                              // alt={row.ax_relation.ItemName}
                              alt={`image_${row.id}`}
                              onError={handleImageError}
                            />
                          </StyledTableCell>
                          // ) 
                          // : col.id === "check" ? (
                          //   <StyledTableCell component="th" scope="row">
                          //     <Checkbox
                          //       checked={modifiedData && modifiedData.map((mod) => {
                          //         if(mod.id == row.id){
                          //             return mod.check
                          //         }else{
                          //             return false
                          //         }
                          //       }
                          //       )}
                          //       value={modifiedData && modifiedData.map((mod) => {
                          //         if(mod.id == row.id){
                          //             return mod.check
                          //         }else{
                          //             return false
                          //         }
                          //       }
                          //       )}
                          //       defaultChecked={false}
                          //       onChange={(e) => handleCheck(e, row)}
                          //     />
                          //   </StyledTableCell>
                        ) : col.id === "quantity" ? (
                          <StyledTableCell>
                            <div
                              style={{
                                display: "flex",
                                height: "50px",
                                alignItems: "center",
                                justifyContent: "center",
                                background:
                                  remainingQty == curr?.productQuantity
                                    ? "#d1ffbd"
                                    : "#ffcccb",
                              }}
                            >
                              {remainingQty}
                            </div>
                            <div style={{
                              color: "grey",
                              fontSize: "12px",
                              lineHeight: "1.4",
                            }}> <small>Avaibale SOH: {parseInt(row?.available_soh)}</small></div>
                          </StyledTableCell>
                        ) : col.id == "ItemName" ? (
                          <StyledTableCell component="th" scope="row">
                            {row?.itemname}
                          </StyledTableCell>
                        ) : col.id == "EANBarcode" ? (
                          <StyledTableCell component="th" scope="row">
                            {row?.ax_details?.EANBarcode}
                          </StyledTableCell>
                        ) : col.id == "SizeID" ? (
                          <StyledTableCell component="th" scope="row">
                            {row?.inventsizeid}
                          </StyledTableCell>
                        ) : col.id == "releasestatus" ? (
                          <StyledTableCell component="th" scope="row">
                            <span style={{ fontWeight: 'bold' }}>
                              {
                                row[col.id] === 1 ? <DoneTwoTone fontSize="large" color="success" /> : <ClearTwoTone fontSize="large" color="error" />
                              }
                            </span>
                          </StyledTableCell>
                        ) : col.id === "confirm" ? (
                          <StyledTableCell>
                            <QuantityBox>
                              <IconButton disabled={row?.isFulfilled === 1} onClick={() => handleRemoveQuantity(row)}>
                                <Remove />
                              </IconButton>
                              <TextField
                                name="productQuantity"
                                type="number"
                                variant="outlined"
                                defaultValue={0}
                                disabled={row?.isFulfilled === 1}
                                value={
                                  curr.productQuantity === 0
                                    ? 0
                                    : curr.productQuantity || 1
                                }
                                onChange={(e) => handleChange(e, row)}
                                style={{ width: "100px" }}
                                InputProps={{
                                  inputProps: {
                                    max: remainingQty,
                                    //max: parseInt(row?.availableSOH),
                                    min: 0,
                                  },
                                }}
                              />
                              <IconButton disabled={row?.isFulfilled === 1} onClick={() => handleAddQuantity(row)}>
                                {" "}
                                <Add />{" "}
                              </IconButton>
                            </QuantityBox>
                          </StyledTableCell>
                        ) : col.id == "action" ? (
                          <StyledTableCell align="left">
                            <>
                              <Button
                                color="primary"
                                variant="outlined"
                              // onClick={() => handleResume(row)}
                              >
                                Pickup
                              </Button>
                            </>
                          </StyledTableCell>
                        ) : col.id == "wmslocationid" ? (
                          <StyledTableCell>
                            <>
                            <TextField
                                name="location"
                                type="text"
                                variant="outlined"
                                value={curr.location}
                                onChange={(e) => handleChangeLocation(e, row)}
                                style={{ width: "120px" }}
                                
                              />
                            </>
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell component="th" scope="row">
                            {row[col.id]}
                          </StyledTableCell>
                        )
                      )}
                    </StyledTableRow>
                  )
                })}
            </TableBody>
            :
            <TableBody>
              {/* <StyledTableRow> */}
              <StyledTableCell component="th" scope="row">
                No Items to Pick up!
              </StyledTableCell>

              {/* </StyledTableRow> */}
            </TableBody>
          }
        </Table>
      </TableContainer>
      {/* {footer !== false && (
        <TablePagination
          rowsPerPageOptions={[10, 20, 50]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )} */}
    </Paper>
  );
}
